import { render, staticRenderFns } from "./RoleList.vue?vue&type=template&id=cee5559e&scoped=true&"
import script from "./RoleList.vue?vue&type=script&lang=ts&"
export * from "./RoleList.vue?vue&type=script&lang=ts&"
import style0 from "./RoleList.vue?vue&type=style&index=0&id=cee5559e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cee5559e",
  null
  
)

export default component.exports